import { render, staticRenderFns } from "./account-manage.vue?vue&type=template&id=36f5c48f&scoped=true"
import script from "./account-manage.vue?vue&type=script&lang=js"
export * from "./account-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f5c48f",
  null
  
)

export default component.exports